// extracted by mini-css-extract-plugin
module.exports = {"root":"az_yN","container":"az_zN","text":"az_AN","--label-align-left":"az_BN","--label-align-right":"az_CN"};